export var getUsersByDate = function (state) { return state.admin.usersByDate; };
export var getUsers = function (state) { return state.admin.users; };
export var getUsersForSavers = function (state) { return state.admin.usersForSaver; };
export var getCarriers = function (state) { return state.admin.carriers; };
export var getRetailers = function (state) { return state.admin.retailers; };
export var getUsersNumber = function (state) { return state.admin.usersNumber; };
export var getComms = function (state) { return state.admin.comms; };
export var getTripCount = function (state) { return state.admin.tripCount; };
export var getAuditsCountSelector = function (state) { return state.admin.auditsCount; };
export var getTrips = function (state) { return state.admin.trips; };
export var getRouteCount = function (state) { return state.admin.routeCount; };
export var getRoutes = function (state) { return state.admin.routes; };
export var getRoute = function (state) { return state.admin.route; };
export var getTripsPage = function (state) { return state.admin.tripsPage; };
export var getAuditsPageSelector = function (state) { return state.admin.auditsPage; };
export var getDashboard = function (state) { return state.admin.dashboard; };
export var getPackagesByCarrier = function (state) { return state.admin.packagesByCarrier; };
export var getMissingPackages = function (state) { return state.admin.missingPackages; };
export var getPartners = function (state) { return state.admin.partners; };
export var getPartnersCountSelector = function (state) { return state.admin.partnersCount; };
export var getPartnersForSavers = function (state) { return state.admin.partnersForSavers; };
export var getTripSummary = function (state) { return state.admin.tripSummary; };
export var getPackageSummary = function (state) { return state.admin.packageSummary; };
export var getAddressValidationFeedback = function (state) {
    return state.admin.getAddressValidationFeedback;
};
export var getOnfleetWorkers = function (state) { return state.admin.onfleetWorkers; };
export var getOnfleetWorkersForRoutesSelector = function (state) {
    return state.admin.onfleetWorkersForRoutes;
};
export var getMainRole = function (state) { return state.admin.role; };
export var getScanResult = function (state) { return state.admin.scanResult; };
export var getPackageTableColumnWidth = function (state) { return state.admin.packageTableColumnWidth; };
export var getSaverTableColumnWidth = function (state) { return state.admin.saverTableColumnWidth; };
export var getTripTableColumnWidth = function (state) { return state.admin.tripTableColumnWidth; };
export var getRoutesTableColumnWidth = function (state) { return state.admin.routesTableColumnWidth; };
export var getConsolidations = function (state) { return state.admin.consolidations; };
export var getCurrentSidebarConsolidationSelector = function (state) {
    return state.admin.currentSidebarConsolidation;
};
export var getContainersSelector = function (state) { return state.admin.containers; };
export var getConsolidationByIdSelector = function (state) { return state.admin.consolidationById; };
export var getConsolidationsCount = function (state) { return state.admin.consolidationsCount; };
export var getConsolidationPackagesCount = function (state) {
    return state.admin.consolidationPackagesCount;
};
export var getContainersCountSelector = function (state) { return state.admin.containersCount; };
export var getConsolidationTableColumnWidth = function (state) {
    return state.admin.consolidationTableColumnWidth;
};
export var getOutboundConsolidationTableColumnWidth = function (state) {
    return state.admin.outboundConsolidationTableColumnWidth;
};
export var getBarcodeScan = function (state) { return state.admin.barcodeScan; };
export var getPackingSlip = function (state) { return state.admin.packingSlip; };
export var getPackageServiceTypes = function (state) { return state.admin.packageServiceTypes; };
export var jobStatusUpdateSelector = function (state) { return state.admin.jobStatusUpdate; };
export var notificationsSelector = function (state) { return state.admin.notifications; };
export var getDummyDriversByHubId = function (state) { return state.admin.getDummyDriversByHubId; };
export var getDrivers = function (state) { return state.admin.getDrivers; };
export var packageConsolidationSelector = function (state) { return state.admin.packageConsolidation; };
//# sourceMappingURL=admin.js.map